// extracted by mini-css-extract-plugin
module.exports = {"createTournModal":"_2oTkIjy","body":"_2Aj-Fdv","content":"_1dXkbmg"};